// Module
var code = `  <div class="alert">
    <span>
      <strong>DISCLAIMER:</strong> This form can be used to move products from one branch to another.
    </span>
  </div>

  <form name="\$ctrl.form">
    <table class="table">
      <thead>
      <tr>
        <th>Select a target and source branch first.</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Source branch</td>
        <td>
          <select ng-disabled="\$ctrl.validatedBranches"
                  ng-model="\$ctrl.sourceBranch"
                  ng-options="\$ctrl.getBranchLabel(branch) for branch in \$ctrl.branches"
                  required>
          </select>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>Target branch</td>
        <td>
          <select ng-disabled="\$ctrl.validatedBranches"
                  ng-model="\$ctrl.targetBranch"
                  ng-options="\$ctrl.getBranchLabel(branch) for branch in \$ctrl.branches"
                  required>
          </select>
        </td>
        <td>
          <button type="button"
                  class="btn btn-primary"
                  ng-disabled="\$ctrl.validatedBranches"
                  ng-click="\$ctrl.validateBranches()">
            Validate branches
          </button>
        </td>
      </tr>
      <tr ng-if="\$ctrl.validatedBranches">
        <td>Selection mode</td>
        <td>
          <select ng-model="\$ctrl.productSelectionMode"
                  ng-options="selectionMode.value as selectionMode.label for selectionMode in \$ctrl.productSelectionModes"
                  ng-change="\$ctrl.onProductSelectionChanged()"
                  required>
          </select>
        </td>
        <td></td>
      </tr>
      <tr ng-if="\$ctrl.validatedBranches && \$ctrl.productSelectionMode === 'ui'">
        <td>Product number</td>
        <td>
          <input
            ng-model="\$ctrl.searchProductNumber"
            type="text"
            autocomplete="off"
            required>
        </td>
        <td>
          <button type="button"
                  class="btn btn-primary"
                  ng-disabled="!(\$ctrl.searchProductNumber.length > 0)"
                  ng-click="\$ctrl.addProduct()">
            Add
          </button>
        </td>
      </tr>
      <tr ng-if="\$ctrl.validatedBranches && \$ctrl.productSelectionMode === 'file'">
        <td>Upload product numbers</td>
        <td>
          <label class="btn btn-default btn-file">
            Load from file...
            <input class="hide"
                   type="file"
                   accept=".txt"
                   file-reader="\$ctrl.file">
          </label>
        </td>
        <td>
          <button type="button"
                  class="btn btn-primary"
                  ng-click="\$ctrl.downloadSample()">
            Download sample
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <div ng-if="\$ctrl.productsToBeUpdated.length > 0">
      <table class="table">
        <thead>
        <tr>
          <th>Products to be moved to another branch</th>
          <th></th>
        </tr>
        <tr>
          <th ng-if="\$ctrl.productSelectionMode === 'ui'">Source branch</th>
          <th>Product number</th>
          <th ng-if="\$ctrl.productSelectionMode === 'ui'">Product type</th>
          <th ng-if="\$ctrl.productSelectionMode === 'ui'">Product name</th>
          <th ng-if="\$ctrl.productSelectionMode === 'ui'">Status</th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="product in \$ctrl.productsToBeUpdated">
          <td ng-if="\$ctrl.productSelectionMode === 'ui'">{{product.sourceBranch}}</td>
          <td>{{product.productNumber}}</td>
          <td ng-if="\$ctrl.productSelectionMode === 'ui'">{{product.productGroup | prettyEnum}}</td>
          <td ng-if="\$ctrl.productSelectionMode === 'ui'">{{product.productName}}</td>
          <td ng-if="\$ctrl.productSelectionMode === 'ui'">{{product.status}}</td>
          <td>
            <button type="button"
                    ng-if="\$ctrl.productSelectionMode === 'ui'"
                    class="btn btn-danger"
                    ng-click="\$ctrl.removeProduct(\$index)">
              Remove
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div ng-if="\$ctrl.productsToBeUpdated.length > 0" class="flex-end">
      <button
        type="button"
        class=" btn btn-success"
        ng-click="\$ctrl.execute()">
        Execute
      </button>
    </div>
  </form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-product-branch/update-product-branch.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;